import React, { useEffect, useRef, useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import Slider from "react-slider";
import { BASE_URL } from "../../constant";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";

const ResponsiveFilterSection = ({
  setCurrentProducts,
  setNavigatedCategory,
  scheme,
  setScheme,
  categories,
  colors,
  sizes,
  brands,
  stockStatus,
  setStockStatus,
  sortByAlphabatically,
  setSortByAlphabatically,
  setSelectedCategory,
}) => {
  const navigate = useNavigate();

  const offcanvasRef = useRef(null);
  const [values, setValues] = useState([0, 100]); // Example price range
  const minPrice = 0;
  const inStockCount = 120;
  const outOfStockCount = 74;

  const [dropdownStates, setDropdownStates] = useState({});
  const [activeCategory, setActiveCategory] = useState(null);

  const [showAll, setShowAll] = useState({
    categories: false,
    colors: false,
    brands: false,
    sizes: false,
  });

  const fetchProducts = (categoryName, item, type) => {
    let url = "";

    if (type === "color") {
      url = `${BASE_URL}/api/customProducts/color?color=${item}`;
    } else if (type === "brand") {
      url = `${BASE_URL}/api/customProducts/brand?brand=${item}`;
    } else if (type === "size") {
      url = `${BASE_URL}/api/customProducts/size?size=${item}`;
    } else if (type === "subcategory") {
      url = `${BASE_URL}/api/customProducts/subcategory?category=${categoryName}&subcategory=${item}`;
    } else {
      url = `${BASE_URL}/api/customProducts/category?category=${categoryName}`;
    }

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        setCurrentProducts(data);
      })
      .catch((error) => console.error("Error fetching products:", error));
  };

  const handleDropdownToggle = (categoryName, item, type, subcategories) => {
    // setIsFilterClicked(true);
    setSelectedCategory(categoryName);
    setActiveCategory((prev) => (prev === categoryName ? null : categoryName));

    if (type === "category") {
      fetchProducts(categoryName, item, "category");
    }

    if (type === "category" && subcategories?.length > 0) return;
    // Fetch products based on category or item type
    fetchProducts(categoryName, item, type);

    if (
      categoryName &&
      typeof categoryName === "string" &&
      categoryName.trim() !== ""
    ) {
      setNavigatedCategory(categoryName);
    }
    setScheme("");

    // Update URL with the type and item/category name
    const searchParams = new URLSearchParams();

    if (type === "category") {
      searchParams.set("category", categoryName);
    } else if (type === "color") {
      searchParams.set("color", item);
    } else if (type === "brand") {
      searchParams.set("brand", item);
    } else if (type === "size") {
      searchParams.set("size", item);
    }

    // Navigate with the updated query params
    navigate(`/shop?${searchParams.toString()}`);
  };

  const handleArrowClick = (categoryName) => {
    setActiveCategory((prev) => (prev === categoryName ? null : categoryName));
  };

  const handleStockStatusChange = (status) => {
    setStockStatus(status);
    closeOffcanvas();
  };

  const handleSchemeChange = (selectedscheme) => {
    if (scheme == selectedscheme) {
      setScheme("");
      closeOffcanvas();
    } else {
      setScheme(selectedscheme);
      closeOffcanvas();
    }
  };

  const closeOffcanvas = () => {
    if (offcanvasRef.current) {
      const offcanvasElement = window.bootstrap.Offcanvas.getInstance(
        offcanvasRef.current
      );
      if (offcanvasElement) {
        offcanvasElement.hide();
      }
    }
  };

  const toggleShowAll = (key) => {
    setShowAll((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const renderFilterSection = (title, data, key, type) => (
    <div className="mb-3">
      <h4>{title}</h4>
      {data?.slice(0, showAll[key] ? data.length : 3)?.map((item, index) => (
        <div key={index}>
          {/* Main Category */}
          <div className="dropdown d-flex">
            <span
              onClick={() =>
                handleDropdownToggle(
                  item.categoryName || item,
                  item.categoryName || item,
                  type,
                  item.subcategoryList
                )
              }
            >
              {item.categoryName || item}
            </span>
            {item.categoryName && (
              <span
                onClick={() => handleArrowClick(item.categoryName)}
                style={{ cursor: "pointer" }}
              >
                {activeCategory === item.categoryName ? (
                  <MdKeyboardArrowDown />
                ) : (
                  <MdKeyboardArrowRight />
                )}
              </span>
            )}
          </div>

          {/* Subcategories */}
          {activeCategory === item.categoryName &&
            item.subcategoryList?.map((subItem) => (
              <div
                key={subItem.subCategoryId}
                className="subcategory-item"
                onClick={(e) => {
                  e.stopPropagation();
                  fetchProducts(
                    item.categoryName,
                    subItem.subCategoryName,
                    "subcategory"
                  );
                }}
              >
                {subItem.subCategoryName}
              </div>
            ))}
        </div>
      ))}

      {/* Show More Button */}
      {data?.length > 3 && (
        <button className="show-more-btn" onClick={() => toggleShowAll(key)}>
          {showAll[key] ? "Show Less" : "Show More"}
        </button>
      )}
    </div>
  );

  return (
    <div>
      {" "}
      <div
        class="offcanvas offcanvas-start"
        tabindex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
        ref={offcanvasRef}
      >
        <div
          class="offcanvas-header"
          style={{ borderBottom: "2px solid silver" }}
        >
          <h1
            style={{ fontWeight: "bold", fontSize: "25px", color: "#5d0b86" }}
            class="offcanvas-title"
            id="offcanvasExampleLabel"
          >
            Filter Products
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div class="offcanvas-body p-4">
          <div className="dropdown-container">
            {renderFilterSection(
              "Shop By Categories",
              categories,
              "categories",
              "category"
            )}
            {renderFilterSection("Shop By Colors", colors, "colors", "color")}
            {renderFilterSection("Shop By Brands", brands, "brands", "brand")}
            {renderFilterSection("Shop By Sizes", sizes, "sizes", "size")}
            <div className="mt-3">
              <div className="d-flex align-items-center gap-2 mb-2">
                <input
                  type="checkbox"
                  className="filter-checkbox"
                  checked={scheme == "offered"}
                  onClick={() => handleSchemeChange("offered")}
                />{" "}
                <p style={{ fontSize: "20px", marginBottom: "0px" }}>
                  Offered Products
                </p>
              </div>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  className="filter-checkbox"
                  checked={scheme == "lightning"}
                  onClick={() => handleSchemeChange("lightning")}
                />{" "}
                <p style={{ fontSize: "20px", marginBottom: "0px" }}>
                  Lightning Deals
                </p>
              </div>
            </div>
          </div>
          <h4 style={{ fontWeight: "bold", fontSize: "20px" }}>Filter By</h4>
          <div className="mb-4">
            <div className="checkbox-container mt-1">
              <h6 style={{ fontSize: "16px", fontWeight: "bold" }}>
                <input
                  type="checkbox"
                  style={{ height: "15px", width: "15px" }}
                  checked={stockStatus === "inStock"}
                  onChange={() => handleStockStatusChange("inStock")}
                />{" "}
                In Stock
              </h6>
              <h6 style={{ fontSize: "16px", fontWeight: "bold" }}>
                <input
                  style={{ height: "15px", width: "15px" }}
                  type="checkbox"
                  checked={stockStatus === "outOfStock"}
                  onChange={() => handleStockStatusChange("outOfStock")}
                />{" "}
                Out of Stock
              </h6>
            </div>
            <div className="price-slider-container">
              <Slider
                className={"price-slider"}
                value={values}
                min={minPrice}
                max={2000}
                onChange={setValues}
              />
              <div className={"range-values"}>
                <span>Rs.{values[0]}</span>
                <span>Rs. {values[1]}</span>
              </div>
            </div>
            <div className="d-flex align-items-center gap-2 justify-content-start mt-3">
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                Sort by
              </p>
              <button
                onClick={() => setSortByAlphabatically(!sortByAlphabatically)}
                type="button"
                className={`${
                  sortByAlphabatically ? "bg-primary text-white" : ""
                }`}
                style={{
                  border: "1px solid black",
                  fontSize: "14px",
                  padding: " 2px 5px",
                  borderRadius: "50px",
                }}
              >
                Alphabetically
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResponsiveFilterSection;
